import { emptyArrayOf } from 'util/array'

export function extractFamiliasResidentes<
  T extends {
    isDomicilioAtivo: boolean
    isInformacaoSuficiente: boolean
    isFamiliaAindaReside: boolean
  }
>(familias: ReadonlyArray<T>): T[] {
  return (familias || emptyArrayOf<T>()).filter(
    (familia) => familia.isDomicilioAtivo && familia.isInformacaoSuficiente && familia.isFamiliaAindaReside
  )
}
